export default __webpack_public_path__ + "static/media/brand.794a1ae9.svg";